module.exports = __webpack_public_path__ + "static/maliat-334010de9450564f991438bc78744330.png";